export const formatCurrency = (amount, currency = null, short = false) => {
  if (amount == -0) {
    amount = 0;
  }
  if (typeof amount === "undefined") {
    return "-";
  }

  let negativeSign = "";
  if (amount < 0) {
    negativeSign = "- ";
    amount = Math.abs(amount);
  }

  try {
    currency = (
      currency ||
      localStorage.getItem("currency")?.toUpperCase() ||
      "SGD"
    )?.toUpperCase();
    const language = localStorage.getItem("locale") || "en";

    if (short) {
      if (
        currency === "USD" ||
        currency === "SGD" ||
        currency === "HKD" ||
        currency === "CAD" ||
        currency === "NZD" ||
        currency === "AUD"
      ) {
        return `${negativeSign}$${amount}`;
      } else if (currency === "IDR") {
        return `${negativeSign}Rp${amount}`;
      } else if (currency === "KRW") {
        return `${negativeSign}₩${amount}`;
      } else if (currency === "JPY") {
        return `${negativeSign}¥${amount}`;
      } else if (currency === "EUR") {
        return `${negativeSign}€${amount}`;
      } else if (currency === "GBP") {
        return `${negativeSign}£${amount}`;
      } else if (currency === "MYR") {
        return `${negativeSign}RM${amount}`;
      } else if (currency === "PHP") {
        return `${negativeSign}₱${amount}`;
      } else if (currency === "THB") {
        return `${negativeSign}฿${amount}`;
      } else if (currency === "VND") {
        return `${negativeSign}₫${amount}`;
      } else if (currency === "TWD") {
        return `${negativeSign}NT$${amount}`;
      } else if (currency === "CNY") {
        return `${negativeSign}${amount}元`;
      }
    }

    if (currency === "USD") {
      return `${negativeSign}USD ${amount}`;
    }

    if (currency === "TWD") {
      return `${negativeSign}NT$${amount}`;
    }

    if (currency === "IDR") {
      // Format IDR in millions (e.g., Rp 8.3M) or thousands (e.g., Rp 8.3K)
      if (amount >= 1000000) {
        const inMillions = (amount / 1000000).toFixed(1);
        // Remove trailing zero if it's a whole number
        const formattedAmount = inMillions.endsWith(".0") ? inMillions.slice(0, -2) : inMillions;
        return `${negativeSign}Rp ${formattedAmount}M`;
      } else if (amount >= 1000) {
        const inThousands = (amount / 1000).toFixed(1);
        // Remove trailing zero if it's a whole number
        const formattedAmount = inThousands.endsWith(".0") ? inThousands.slice(0, -2) : inThousands;
        return `${negativeSign}Rp ${formattedAmount}K`;
      }
      return `${negativeSign}Rp ${amount}`;
    }

    const formatter = new Intl.NumberFormat(language, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return `${negativeSign}${formatter.format(amount)}`;
  } catch (error) {
    console.error("Error formatting currency:", error);
    return `${amount}`; // Fallback to just the amount if formatting fails
  }
};
